var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.6517 19.1668H.98V6.8785h3.6717v12.2883zM2.8629 5.1938c-1.1297 0-2.0712-.991-2.0712-2.1801 0-1.1892.9415-2.1802 2.0712-2.1802 1.1298 0 2.0712.991 2.0712 2.1802s-.9415 2.1802-2.0712 2.1802zm15.3455 13.973h-3.6716v-5.9459c0-1.3874 0-3.2703-1.8829-3.2703s-2.1653 1.5856-2.1653 3.1712v6.045H6.817V6.8785h3.5775v1.6847h.0941c.4707-.991 1.6946-1.982 3.3892-1.982 3.6716 0 4.3306 2.5766 4.3306 5.8469v6.7387z"}));
}

Linkedin.defaultProps = {"fill":"none","viewBox":"0 0 19 20"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
